@use '../../../assets/styles/utilities.scss';

:host {
  display: block;
  width: 100%;
  position: relative;
}

nav.scrolled.transparent {
  background-color: transparent;
}

.w-container-responsive {
  margin: auto;
  width: calc(100vw - 40px); /* 20px * 2 for mobile */
}

@media (min-width: 1024px) {
  .w-container-responsive {
    width: calc(100vw - 188px); /* 94px * 2 for laptops */
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeout {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.fade-in {
  animation: fadeIn 0.3s ease-out;
}

.fade-out {
  animation: fadeout 0.3s ease-in;
}

@layer utilities {
  .scroll-marquee {
    display: inline-block;
    white-space: nowrap;
    animation: marquee 20s linear infinite; /* faster by default */
    will-change: transform;
    position: absolute;

    &:hover {
      animation-play-state: paused;
    }
  }

  @keyframes marquee {
    0% {
      transform: translateX(100vw);
    }
    100% {
      transform: translateX(-100%);
    }
  }

  @media (min-width: 640px) {
    .scroll-marquee {
      animation-duration: 35s;
    }
  }
}
